export default __webpack_public_path__ + "static/Teemates-2ac0bd3f9d0c19681e8859be099dce1c.webp";